import React from "react";
import "./SectionSubheading.scss";

export const SectionSubheading = ({
  children,
  style = {},
  persistCenter = true,
}: {
  children: React.ReactNode;
  persistCenter?: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <h1
      className={`section-sub-heading ${
        persistCenter ? "" : "text-align-start"
      }`}
      style={style}
    >
      {children}
    </h1>
  );
};
